export default __webpack_public_path__ + "static/media/iPad Navbar 2.c15d8003.png";